import React from 'react'
import { cn } from 'src/lib/utils'

interface GridProps<T> {
  items: T[]
  renderItem: (item: T, index: number) => React.ReactNode
  keyExtractor: (item: T) => string | number
  className?: string
  columns?: number
}

const gridColumnClasses: Record<number, string> = {
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
  5: 'md:grid-cols-5',
  6: 'md:grid-cols-6',
  7: 'md:grid-cols-7',
  8: 'md:grid-cols-8',
  9: 'md:grid-cols-9',
  10: 'md:grid-cols-10',
  11: 'md:grid-cols-11',
  12: 'md:grid-cols-12',
}

export const Grid = <T,>({ items, renderItem, keyExtractor, className, columns = 3 }: GridProps<T>): React.ReactElement => {
  const columnClass = gridColumnClasses[columns] || gridColumnClasses[3]

  return (
    <div className={cn('grid grid-cols-1 gap-7', columnClass, className)}>
      {items.map((item, index) => (
        <React.Fragment key={keyExtractor(item)}>{renderItem(item, index)}</React.Fragment>
      ))}
    </div>
  )
}

interface GridSkeletonProps {
  count?: number
  columns?: number
  children: React.ReactNode
  className?: string
}

Grid.Skeleton = ({ count = 3, columns = 3, children, className }: GridSkeletonProps): React.ReactElement => {
  const columnClass = gridColumnClasses[columns] || gridColumnClasses[3]

  return (
    <div className={cn('grid grid-cols-1 gap-7', columnClass, className)}>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>{children}</React.Fragment>
      ))}
    </div>
  )
}
